import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export interface CenteredCardLayoutProps {
	children: ReactNode;
	className?: string;
}

function CenteredCardLayout({
	children,
	className,
}: CenteredCardLayoutProps): ReactNode {
	return (
		<div
			className={cn(
				"flex min-h-screen items-center justify-center p-4 bg-background",
				className,
			)}
		>
			<div className="w-full max-w-md rounded-lg border border-border bg-card p-8 shadow-sm">
				{children}
			</div>
		</div>
	);
}
CenteredCardLayout.displayName = "CenteredCardLayout";

export default CenteredCardLayout;
export { CenteredCardLayout };
